import dayjs from "dayjs";

export default {
  getUrlKey: function (name) {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  },
  formatDate: function (date) {
    return dayjs(new Date(date)).format("YYYY年MM月DD日");
  },
  formatDateType: function (date, type) {
    return dayjs(new Date(date)).format(type);
  },
  compareDate: function (date) {
    let now = new Date();
    return now.getTime() > date;
  },
  getUrlHash: function () {
    let hash = window.location.hash;
    if (!hash) return {};

    let hashArray = hash.substr(1).split("&");
    let result = {};
    hashArray
      .filter((it) => {
        return it;
      })
      .forEach((it) => {
        let splits = it.split("=");
        result[decodeURIComponent(splits[0])] = decodeURIComponent(splits[1]);
      });
    return result;
  },
  setUrlHash: function (name, value) {
    let urlHash = this.getUrlHash();
    urlHash[name] = value;

    let hashStr = "#";
    for (let key in urlHash) {
      if (!key) continue;
      let value = urlHash[key];
      if (!value) continue;
      hashStr +=
        encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    window.location.hash = hashStr;
  },
};



// WEBPACK FOOTER //
// ./src/plugin/utils.js